import { SPINNER_SHOW, SPINNER_HIDE, SPINNER_ACTIVATION, SpinnerActivationAction } from './action-creators';
import { PAGE_UPDATE_SUCCESS, PAGE_LOAD_ABORTED, PAGE_LOAD_DONE } from '../CurrentPage/action-creators';
import { Spinner } from '../State';
import { Action } from 'redux';

export default function(state: Spinner | null = null, action: Action): Spinner {
  if (state === null) {
    state = {
      isVisible: false,
      isCommunicatingWithServer: false,
    };
  }
  switch (action.type) {
    case SPINNER_SHOW:
      return {
        ...state,
        isVisible: true,
      };
    case SPINNER_HIDE:
      return {
        ...state,
        isVisible: false,
      };
    case SPINNER_ACTIVATION: {
      const spinnerLoadingAction = action as SpinnerActivationAction;
      return {
        ...state,
        isCommunicatingWithServer: spinnerLoadingAction.active,
      };
    }
    case PAGE_UPDATE_SUCCESS:
    case PAGE_LOAD_ABORTED:
    case PAGE_LOAD_DONE:
      return {
        isVisible: false,
        isCommunicatingWithServer: false,
      };
    default:
      return state;
  }
}
